import React from "react";

const UserAgreement = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>User Agreement</h1>

      <p>
        1️⃣ Privacy and Data Usage: The parties acknowledge that all SQL
        schemas and related information provided by the Client will only be
        used by the Provider for the purpose of performing the contracted
        service. SQL schemas will only be stored in RAM, will not be logged,
        and will not be stored on disk or any other persistent medium. All
        temporary files and outputs created will be permanently deleted no
        later than 24 hours after processing is completed.
      </p>
      <p>
        2️⃣ Intellectual Property and License: All rights to the delivered
        software infrastructure belong to the Client. The Provider claims no
        rights over the delivered source code or infrastructure; the Client may
        use, modify, and develop the delivered infrastructure as desired.
      </p>
      <p>
        3️⃣ Liability and Warranty: The Provider accepts no responsibility for
        the accuracy of the SQL content or data types provided. The Client
        guarantees that the submitted SQL schema contains only empty
        structures and no real data. The Client is responsible for the legal
        ownership of the submitted schema. The Provider is not liable for any
        third-party claims arising from incorrect or unauthorized use of the
        submitted schemas. The Provider delivers only the schema and
        unfinished project infrastructure. Any use of the project before
        completion or development is the sole responsibility of the Client.
        The Client is obliged to review all codes and develop them as desired.
        Errors, losses, or damages resulting from direct use or development of
        the delivered infrastructure are not accepted by the Provider.
      </p>
      <p>
        4️⃣ GDPR / KVKK Compliance: The parties acknowledge that the submitted
        content must not contain personal data. The Provider will process the
        SQL schema only within the scope of the contracted service and will
        permanently delete all data, keeping no copies.
      </p>
      <p>
        5️⃣ Delivery and Use: The Client guarantees that the schemas to be
        delivered contain only the database structure (schema). The Provider
        will develop and deliver software/project infrastructure according to
        the schema. The delivered code and infrastructure are open for the
        Client's use and development.
      </p>
      <p>
        6️⃣ Payment and Service Scope: Fees and payment terms will be agreed
        upon by the parties. The Provider is not obliged to provide support or
        maintenance services after delivery; additional support requires a
        separate agreement.
      </p>
      <p>
        7️⃣ General Provisions: This agreement comes into force when signed
        by the parties. Matters not covered in the agreement will be resolved
        by the parties in good faith.
      </p>
      <p>
       8️⃣ Third-Party Licenses:
       In case any license requirements arise from third-party tools, software, 
       libraries, or services used within the project, the user is fully 
       responsible for acquiring, managing, and maintaining such licenses. 
       We do not assume any legal, financial, or operational responsibility 
       regarding license agreements or obligations belonging to external companies.
      </p>
      <hr style={{ margin: "30px 0" }} />

      <h1>Kullanıcı Sözleşmesi</h1>

      <p>
        1️⃣ Gizlilik ve Veri Kullanımı: Taraflar, Alıcı tarafından sağlanan tüm
        SQL şemaları ve şema ile ilgili bilgiler için şunları kabul eder:
        Sağlayıcı, SQL şemalarını yalnızca sözleşme konusu hizmetin ifası
        için kullanacaktır. SQL şemaları sadece RAM’de tutulacak, loglanmayacak,
        disk veya başka kalıcı ortamda saklanmayacaktır. Oluşturulan tüm
        geçici dosyalar ve çıktılar, işlem tamamlandıktan sonra en geç 24 saat
        içinde kalıcı olarak silinecektir.
      </p>
      <p>
        2️⃣ Fikri Mülkiyet ve Lisans: Teslim edilen yazılım altyapısının tüm
        hakları müşteriye aittir. Sağlayıcı, teslim edilen kaynak kod veya
        altyapı üzerinde hiçbir hak talep etmez; Müşteri teslim edilen altyapıyı
        istediği şekilde kullanabilir, değiştirebilir ve geliştirebilir.
      </p>
      <p>
        3️⃣ Sorumluluk ve Garanti: Sağlayıcı, kendisine iletilen SQL
        içeriğinin doğruluğu veya içindeki veri türleri hakkında sorumluluk
        kabul etmez. Müşteri, gönderdiği SQL şemasının yalnızca boş bir şema
        olmasını ve herhangi bir gerçek veri içermemesini taahhüt eder. Müşteri,
        gönderdiği şemanın yasal ve sahiplik açısından sorumluluğunu taşır.
        Sağlayıcı, gönderilen şemaların yanlış veya gizli kullanımı sonucu
        doğan üçüncü taraf taleplerinden sorumlu tutulamaz. Uygulamadan veya
        teslim edilen altyapıdan kaynaklanan hiçbir zarardan Sağlayıcı
        sorumlu değildir. Sağlayıcı yalnızca şema ve bitmemiş proje altyapısı
        teslim eder. Projenin tamamlanmadan veya geliştirilmeden kullanılması
        durumunda tüm sorumluluk müşteriye aittir. Müşteri, tüm kodları
        inceleyip kendi isteğine göre geliştirmekle yükümlüdür. Teslim edilen
        altyapının doğrudan kullanımı veya geliştirilip kullanılması sonucu
        oluşacak hatalar, kayıplar veya zararlar Sağlayıcı tarafından
        kabul edilmez.
      </p>
      <p>
        4️⃣ KVKK / GDPR Uyumluluğu: Taraflar, gönderilen içerikte kişisel veri
        bulunmaması gerektiğini kabul eder. Sağlayıcı, yalnızca sözleşme
        konusu hizmet kapsamında SQL şemasını işleyecek ve verileri kalıcı
        olarak silerek hiçbir kopyasını saklamayacaktır.
      </p>
      <p>
        5️⃣ Teslim ve Kullanım: Müşteri, teslim edilecek şemaların yalnızca
        veri tabanı yapısını (schema) içereceğini garanti eder. Sağlayıcı,
        şemaya uygun yazılım altyapısı / proje altyapısı geliştirip teslim
        edecektir. Teslim edilen kod ve altyapı, müşterinin kullanımına ve
        geliştirmesine açıktır.
      </p>
      <p>
        6️⃣ Ödeme ve Hizmet Kapsamı: Ücret ve ödeme şartları taraflarca
        kararlaştırılacaktır. Sağlayıcı, teslim sonrası destek veya bakım
        hizmeti vermekle yükümlü değildir; ek destek gerekiyorsa ayrı
        sözleşme yapılır.
      </p>
      <p>
        7️⃣ Genel Hükümler: Bu sözleşme, taraflarca imzalandığı anda yürürlüğe
        girer. Sözleşmede yer almayan konular Taraflar arasında iyi niyet
        çerçevesinde çözülür.
      </p>
      <p>
        8️⃣ Üçüncü Taraf Lisansları:
        Proje kapsamında kullanılan üçüncü taraf araçlar, yazılımlar, 
        kütüphaneler veya hizmetlerle ilgili herhangi bir lisans gereksinimi 
        olması durumunda, bu lisansların temin edilmesi, yönetilmesi ve 
        sürdürülmesinden kullanıcı sorumludur. Dış şirketlere ait lisans 
        anlaşmaları ve yükümlülükleri konusunda tarafımız herhangi bir hukuki, 
        mali veya operasyonel sorumluluk kabul etmez.
      </p>
    </div>
  );
};

export default UserAgreement;
